<template>
  <div
      :class="'result-map-wrapper' + (expanded ? ' expanded':'') + (MapLoading ?' loading':'') + (expandMap ?' mobile-visible':'')">
    <div ref="map" class="results-map" allow-wide></div>
    <button class="map-expander" v-on:click="resizeMap"></button>
    <div hidden>
      <div ref="info" class="infoCard">
        <div class="infoCard" v-if="infoMarker">
          <a :href="'/property/'+infoMarker.propertyResult.UrlSlug+ '?tab=' + infoMarker.propertyResult.first_listing.ListingTypeName">
            <img :src="infoMarker.propertyResult.imageUrl">
          </a>
          <div>
            <a :href="'/property/'+infoMarker.propertyResult.UrlSlug+ '?tab=' + infoMarker.propertyResult.first_listing.ListingTypeName">
              <h2>
                {{
                  infoMarker.propertyResult.propertyName ? infoMarker.propertyResult.propertyName : infoMarker.propertyResult.AddressLine1
                }}
              </h2>
            </a>
            <p>
              <span
                  v-if="infoMarker.propertyResult.propertyName && infoMarker.propertyResult.propertyName !== infoMarker.propertyResult.AddressLine1"
              >
                {{ infoMarker.propertyResult.AddressLine1 }}
                <br>
              </span>
              {{ infoMarker.propertyResult.City }}, {{ infoMarker.propertyResult.StateAbbreviatedName }}<br>
              <span v-if="sfRate(infoMarker.propertyResult) !== null">
                {{ sfRate(infoMarker.propertyResult) }}
              </span>
              <br>
              {{ infoMarker.propertyResult.spaceDescription }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'google-map',
  props: ['results', 'loading', 'expandMap'],
  data() {
    return {
      map: null,
      expanded: false,
      markers: [],
      bounds: null,
      infoWindow: null,
      infoMarker: null,
      USABounds: new google.maps.LatLngBounds({lat: 24.396308, lng: -124.848974}, {lat: 49.384358, lng: -66.885444}),
      MapIcon: {anchor: {x: 28.5, y: 40}, url: '/icons/newmark-map-pin.svg?v=123', scaledSize: {width: 40, height: 40}},
      MapLoading: false,
    };
  },
  mounted() {
    this.map = new google.maps.Map(this.$refs.map, {
      zoom: 8,
      center: {lat: 35.4690248, lng: -97.51603090000003},
      styles: [
        {stylers: [{hue: "#d2d2d2"}, {saturation: -100}]},
        {
          featureType: "road", elementType: "geometry",
          stylers: [{lightness: 100}, {visibility: "simplified"}]
        },
        {
          featureType: "road", elementType: "labels",
          stylers: [{visibility: "on"}]
        },
        {
          featureType: 'poi.business', elementType: 'geometry',
          stylers: [{hue: '#ebd3ce'}, {saturation: 32},
            {lightness: 10}, {visibility: 'on'}]
        }]
    });

    this.results.forEach(result => this.markResult(result));
    this.infoWindow = new google.maps.InfoWindow();
    google.maps.event.addListener(this.infoWindow, 'closeclick', () => this.infoWindowClose());
    google.maps.event.addListener(this.map, 'bounds_changed', () => this.checkVisibleMarkers());
  },
  watch: {
    results(newVal) {
      this.MapLoading = true;
      this.markers.forEach(marker => marker.setMap(null));
      this.markers = [];
      newVal.forEach(result => this.markResult(result));
      this.bound();
      Vue.nextTick(() => this.MapLoading = false);
    },

    loading(newVal) {
      if (newVal) this.MapLoading = true;
    },
    expandMap(newVal) {
      if (newVal) Vue.nextTick(() => {
        google.maps.event.trigger(this.map, 'resize');
        this.bound();
      });
    }
  },
  methods: {
    bound() {
      // this.map.fitBounds(this.USABounds);
      if (this.markers.length > 0) {
        this.bounds = new google.maps.LatLngBounds();
        this.markers.forEach(marker => this.bounds.extend(marker.position));
        this.map.fitBounds(this.bounds, 10);
      }
    },
    resizeMap() {
      let center = this.map.getCenter();
      this.expanded = !this.expanded;
      setTimeout(() => {
        google.maps.event.trigger(this.map, 'resize');
        this.map.setCenter(center);
      }, 500);
    },
    showInfo(marker) {
      this.infoWindow.close();
      this.infoMarker = marker;
      this.infoWindow.setContent(this.$refs.info);
      Vue.nextTick(() => this.infoWindow.open(this.map, marker));
    },
    infoWindowClose() {
      this.infoMarker = null;
    },
    markResult(result) {
      let pos = {
        lat: Number(result.latitude),
        lng: Number(result.longitude)
      };

      if (![pos.lat, pos.lng].includes(NaN)) { // && this.USABounds.contains(pos)){
        let marker = new google.maps.Marker({
          position: pos,
          icon: this.MapIcon,
          map: this.map,
        });
        marker.propertyResult = result;
        marker.addListener('click', () => this.showInfo(marker));
        this.markers.push(marker);
      }
    },
    checkVisibleMarkers() {
      let visibleMarkers = [];
      this.markers.forEach(m => {
        if (this.map.getBounds().contains(m.getPosition()))
          visibleMarkers.push(m.propertyResult.propertyId);
      });
      this.$emit('markerVisibility', visibleMarkers);
    },
    sfRate(property) {
      let price = property.first_listing.AskingPriceAmount || property.first_listing.RentAmount;
      if (price === null) return null;
      price = Number(price);
      return price.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
    },
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PropertySearch/Map.vue